import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { usePageTypeContent } from "../../hooks/UseContentHook";
import { ReferenceMapsPage, ReferenceMapsPageProps } from "./ReferenceMapsPage";

export const EMPTY_PAGE_CONTENT: ReferenceMapsPageProps = {
  pageTitle: "",
};

export const CANONICAL_LINK = "/personal/help-safety/near-our-network/reference-plans";

export const ReferenceMapsPageContainer: React.FC<RouteComponentProps> = routeProps => {
  const { content } = usePageTypeContent<ReferenceMapsPageProps>("reference_maps_page", EMPTY_PAGE_CONTENT);
  if (content.seo) {
    content.seo.canonicalLink = CANONICAL_LINK;
  }
  return <ReferenceMapsPage {...routeProps} {...content} />;
};
